import { useRef } from "react";
import type { RefObject } from "react";
import { useProfileMergeStore } from "@/stores/profile-merge-store";

/** Active-step wiring for one merge card of the guided review (see
 *  ProfileMergeGuide): the ref the guide scrolls, and capture handlers that
 *  pull the guide to the card on any interaction inside it. */
export function useGuideCard(stepKey: string): {
  cardRef: RefObject<HTMLDivElement | null>;
  activationProps: { onClickCapture: () => void; onFocusCapture: () => void };
} {
  const activateStep = useProfileMergeStore((s) => s.activateStep);
  const cardRef = useRef<HTMLDivElement>(null);
  const activate = () => activateStep(stepKey);
  return { cardRef, activationProps: { onClickCapture: activate, onFocusCapture: activate } };
}
